import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { HTMLTagProps } from '../../../../types';
type BottomDrawerContentsProps = HTMLTagProps<'div'>;
export const Contents = t0 => {
  const $ = _c(8);
  let className;
  let restProps;
  if ($[0] !== t0) {
    ({
      className,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = restProps;
  } else {
    className = $[1];
    restProps = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("relative mx-20 mb-16 box-border max-w-full flex-1 overflow-auto hide-scrollbar webkit-scroll-touch", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== restProps || $[6] !== t1) {
    t2 = <div {...restProps} className={t1} />;
    $[5] = restProps;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};